/* esm.sh - nano-css@5.6.2/addon/vcssom/cssToTree */
export * from "/*nano-css@5.6.2/esnext/addon/vcssom/cssToTree.mjs";
export { default } from "/*nano-css@5.6.2/esnext/addon/vcssom/cssToTree.mjs";
